export default "__VITE_ASSET__5983b514__"